import { Config } from '@leverege/plugin'

export default {
  id : 'ps.action.OpenEventEndImageUrl',
  matches : {
    client : 'LinearViewBlock'
  },
  layout : {
    group : [ 'Image', 'End' ],
    groupIcons : [ 'fa fa-fw fa-camera' ]
  },
  appearance : () => ( {
    name : 'Open',
    icon : 'fa fa-fw fa-external-link'
  } ),
  handles : ( context ) => {
    const { item } = context
    
    return item?.stopData != null
  },
  perform : ( { context } ) => {
    const { item } = context
    const imageBucketUrl = Config.get( 'LinearViewBlock', 'gcsImageBucketUrl' )
    window.open( `${imageBucketUrl}/${item.stopData.imagePath}`, '_blank' ).focus()
  }
}
